<template>
  <div :class="classList">
    <label v-if="label"
      >{{ label.trim().replace(/\*$/, "") }}
      <span v-if="isRequired" class="asterisk-mark">*</span></label
    >
    <div
      v-if="adminDescription && $store.getters.isAgent"
      class="admin-description"
    >
      <div v-html="adminDescription"></div>
    </div>
    <div v-if="description" class="description">
      <div v-html="description"></div>
    </div>
    <div
      class="rating-container"
      :class="{ disabled: disabled }"
      :style="{ minWidth: 5 * starSize + 'px' }"
    >
      <div
        :key="star"
        v-for="star in maxStars"
        @mouseover="hoverStar(star)"
        @mouseleave="mouseLeftStar"
        :class="[{ active: star <= stars }]"
        @click="rate(star)"
        class="rating-item"
      >
        <span class="rate-star">
          <i
            :style="{ 'font-size': starSize + 'px' }"
            class="material-icons"
            v-if="star <= stars"
          >
            grade
          </i>
          <i
            :style="{ 'font-size': starSize + 'px' }"
            class="material-icons"
            v-else
            :class="{ 'star-hover': hoverItem && hoverItem >= star }"
          >
            star_outline
          </i>
        </span>
      </div>
      <span
        class="star-description"
        :class="starDesc.class"
        v-if="starDesc.text && showRating"
        >{{ starDesc.text }}</span
      >
    </div>
    <!-- <span v-if="stars" class="rating-result"
      >{{ stars }} of {{ maxStars }}</span
    > -->
    <p class="required-message" v-if="!stars && submitClicked && isRequired">
      {{ getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED") }}
    </p>
  </div>
</template>

<script>
export default {
  name: "StarRating",
  data() {
    return {
      stars: this.value,
      starDesc: {},
      hoverItem: null,
    };
  },
  props: {
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12",
    },
    value: {
      type: [Number, String],
    },
    maxStars: {
      type: Number,
      default: 5,
    },
    ratingDescription: {
      type: Array,
      default: () => {
        return [
          {
            text: "Poor",
            class: "star-poor",
          },
          {
            text: "Below Average",
            class: "star-belowAverage",
          },
          {
            text: "Average",
            class: "star-average",
          },
          {
            text: "Good",
            class: "star-good",
          },
          {
            text: "Excellent",
            class: "star-excellent",
          },
        ];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // Mark if the field is required
    isRequired: {
      type: Boolean,
      default: false,
    },
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false,
    },
    starSize: {
      type: Number,
      default: 32,
    },
    showRating: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    rate(star) {
      if (this.disabled) {
        return;
      }
      if (star <= this.maxStars && star >= 0) {
        this.stars = this.stars === star ? star - 1 : star;
      }
      this.$emit("input", this.stars);
    },
    hoverStar(star) {
      if (this.disabled) {
        return;
      }
      this.hoverItem = star;
      if (star <= this.maxStars && star >= 0) {
        this.starDesc = this.ratingDescription[star - 1];
      }
    },
    mouseLeftStar() {
      if (this.disabled) {
        return;
      }
      this.hoverItem = null;
      if (this.stars) {
        this.starDesc = this.ratingDescription[this.stars - 1];
        return this.starDesc;
      } else {
        this.starDesc = "";
      }
    },
    getRatingDesc(star) {
      if (star) {
        this.starDesc = this.ratingDescription[star - 1];
      }
      return this.starDesc;
    },
  },
};
</script>

<style lang="css">
.rating-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: fit-content;
}

.rating-item {
  cursor: pointer;
}

.rating-container.disabled .rating-item {
  cursor: default;
}

.star-description {
  margin-left: 1em;
  min-width: 130px;
  padding: 0.5em;
  text-align: center;
  font-weight: 700;
  color: white;
}

.active {
  color: #f3d23e;
}
.star-poor {
  background: rgb(186, 186, 186);
}
.star-belowAverage {
  background: rgb(245, 195, 87);
}
.star-average {
  background: rgb(255, 172, 90);
}
.star-good {
  background: rgb(193, 215, 89);
}
.star-excellent {
  background: rgb(72, 150, 77);
}

.rating-result {
  margin-left: 0.5em;
  font-family: Segoe UI, Tahoma, Geneva, Verdana, sans-serif;
}

.star-hover {
  color: #f3d23e;
}
</style>


// WEBPACK FOOTER //
// src/components/common/complex-input-elements/StarRating.vue